/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quiet_Neat_Hen_HowlInputs */

const en_quiet_neat_hen_howl = /** @type {(inputs: Quiet_Neat_Hen_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete selected`)
};

const de_quiet_neat_hen_howl = /** @type {(inputs: Quiet_Neat_Hen_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte löschen`)
};

/**
* | output |
* | --- |
* | "Delete selected" |
*
* @param {Quiet_Neat_Hen_HowlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quiet_neat_hen_howl = /** @type {((inputs?: Quiet_Neat_Hen_HowlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quiet_Neat_Hen_HowlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quiet_neat_hen_howl(inputs)
	return de_quiet_neat_hen_howl(inputs)
});